module.exports = __webpack_public_path__ + "img/loading-payment.ea5ac45c.svg";